import { Outlet, createFileRoute } from '@tanstack/react-router';

import PageContainer from '@/components/layout/PageContainer';
import SidebarNav from '@/components/layout/SidebarNav';
import { useAuthorizationLinks } from '@/utils/linkAuth';
import { tenantSettingsSidebarItems } from '@/constants/navigation/tenantSettings';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings',
)({
  component: function Container() {
    const items = useAuthorizationLinks(tenantSettingsSidebarItems);

    return (
      <PageContainer
        title="Configurações"
        subtitle="Gerencie as configurações da sua organização."
        withSeparator
      >
        <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
          <aside className="lg:w-1/5">
            <SidebarNav items={items} />
          </aside>
          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </PageContainer>
    );
  },
});
